import { LinkIconPlacement } from '@property.com.au/ui-kit';
import { IconInfo, LinkIconName } from '../components/types';

type ApiIconInfoName = LinkIconName;
type ApiIconInfoPlacement = 'LEFT' | 'RIGHT' | null;

const mapPlacement = (placement: ApiIconInfoPlacement): LinkIconPlacement | null => {
  switch (placement) {
    case 'LEFT':
      return 'left';
    case 'RIGHT':
      return 'right';
    default:
      return null;
  }
};

export const mapApiWeblinkIconInfoToLinkIconInfo = ({
  name,
  placement,
}: {
  name: ApiIconInfoName;
  placement: ApiIconInfoPlacement;
}): IconInfo => {
  return {
    name,
    placement: mapPlacement(placement),
  };
};
